import React from "react";
import ReactDOM from "react-dom/client";
import Root from "./Root";
import { hideSplash, isIOS, isNativePlatform, setStatusBarStyle, initBackButtonListener } from "./lib/capacitor";

// Capacitor 原生初始化
if (isNativePlatform) {
  document.documentElement.classList.add("is-native-app");
  void setStatusBarStyle("dark", true);
  void hideSplash();
  initBackButtonListener();
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
